/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';
// import {ArrowRight} from '@material-ui/icons';
import useAuth from 'src/hooks/useAuth';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { VALIDATE_REGEX } from 'src/constants';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { changePassword } from 'src/slices/users';
import { Button } from 'src/components';

const Access = props => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  let history = useHistory();
  const [userData, setUserData] = useState(null);
  const goBack = () => {
    history.push('/profile');
  };
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState(undefined);
  const [successMsg, setSuccessMsg] = useState(undefined);
  const [specialCase, setSpecialCase] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [number, setNumber] = useState(false);
  const [length, setLength] = useState(false);

  const isValidPassword = [specialCase, upperCase, number, length].every(i => i) && password === confirmPassword;

  useEffect(() => {
    if (user) {
      setUserData(user);
    }
  }, [user]);

  const savePassword = () => {
    let payload = {
      uuid: user.uuid,
      password: password
    };
    if (isValidPassword) {
      dispatch(changePassword(payload)).then(response => {
        if (response) {
          setSuccessMsg(t('Access.successMsg'));
          setTimeout(reset, 3000);
        }
      });
    }
  };

  const reset = () => {
    setConfirmPassword('');
    setPassword('');
    setSuccessMsg(undefined);
    setSpecialCase(false);
    setUpperCase(false);
    setNumber(false);
    setLength(false);
  };

  const passwordValidate = e => {
    const { value } = e.target;
    setPassword(value);
    validateHighlight(value);
    if (confirmPassword && confirmPassword === value) {
      let validation = regexValidate(value);
      if (validation) {
        setErrorMsg(undefined);
      } else {
        setErrorMsg(t('Access.reqPasswordNotFulfil'));
      }
    } else if (confirmPassword) {
      setErrorMsg(t('Access.passwordNotMatch'));
    } else if (!confirmPassword) {
      setErrorMsg(undefined);
    }
  };

  const confirmPasswordValidate = e => {
    const { value } = e.target;
    setConfirmPassword(value);
    if (password === value) {
      let validation = regexValidate(value);
      if (validation) {
        setErrorMsg(undefined);
      } else {
        setErrorMsg(t('Access.reqPasswordNotFulfil'));
      }
    } else {
      setErrorMsg(t('Access.passwordNotMatch'));
    }
  };

  const regexValidate = value => {
    return VALIDATE_REGEX.password.test(value);
  };

  const validateHighlight = value => {
    let specialCaseLetters = /[!,;`~'":{}<>^/@#$%&*?|\\[\])(+=._-]/;

    if (value.match(specialCaseLetters)) {
      setSpecialCase(true);
    } else {
      setSpecialCase(false);
    }

    // Validate capital letters
    let upperCaseLetters = /[A-Z]/g;
    if (value.match(upperCaseLetters)) {
      setUpperCase(true);
    } else {
      setUpperCase(false);
    }

    // Validate numbers
    let numbers = /[0-9]/g;
    if (value.match(numbers)) {
      setNumber(true);
    } else {
      setNumber(false);
    }

    // Validate length
    if (value.length >= 8) {
      setLength(true);
    } else {
      setLength(false);
    }
  };

  const breadcrumbData = [
    {
      title: t('profile.title'),
      link: '/profile',
      options: [
        {
          title: t('profile.title'),
          link: '/profile'
        },
        {
          title: t('personalData.title'),
          link: '/personaldata'
        },
        {
          title: t('Access.title'),
          link: '/access'
        }
      ]
    },
    {
      title: t('Access.title')
    }
  ];

  return (
    <section className="main_content profile">
      <Breadcrumb data={breadcrumbData} additionClassName="container-narrow" />
      <div className="container container-narrow">
        {/* <h4 className="page_subtitle">{t('profile.subTitle')}</h4> */}
        <Grid className="personal-data-container access">
          <h2 className="page_title">{t('Access.title')}</h2>
          <Grid className="access__card">
            <h4 className="sub_head">{t('Access.username')}</h4>
            <Grid className="access__card-head">
              <Grid>
                <TextField
                  id="standard-full-width-username"
                  label={t('Access.username')}
                  placeholder={userData?.email}
                  fullWidth
                  className="access__text-field"
                  margin="normal"
                  InputProps={{
                    readOnly: true
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid className="access__card">
            <h4 className="sub_head">{t('Access.changepassword')}</h4>
            <Grid className="access__card-head">
              <Grid>
                <TextField
                  type="password"
                  id="standard-full-width-password"
                  label={t('Access.NewPassword')}
                  placeholder={t('Access.NewPassword')}
                  fullWidth
                  className="access__text-field"
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={password}
                  onChange={e => passwordValidate(e)}
                />
              </Grid>
              <Grid className="access__instruction-wrapper">
                <div className={clsx('access__instruction', length && 'access__instruction--valid')}>
                  <CheckCircleOutline className={clsx('access__icon', length && 'access__icon--valid')} />{' '}
                  {t('Access.instruction_1')}
                </div>
                <div className={clsx('access__instruction', upperCase && 'access__instruction--valid')}>
                  <CheckCircleOutline className={clsx('access__icon', upperCase && 'access__icon--valid')} />{' '}
                  {t('Access.instruction_2')}
                </div>
                <div className={clsx('access__instruction', number && 'access__instruction--valid')}>
                  <CheckCircleOutline className={clsx('access__icon', number && 'access__icon--valid')} />{' '}
                  {t('Access.instruction_3')}
                </div>
                <div className={clsx('access__instruction', specialCase && 'access__instruction--valid')}>
                  <CheckCircleOutline className={clsx('access__icon', specialCase && 'access__icon--valid')} />{' '}
                  {t('Access.instruction_4')}
                </div>
              </Grid>
              <Grid>
                <TextField
                  type="password"
                  id="standard-full-width-re-password"
                  label={t('Access.repeatNewPassword')}
                  placeholder={t('Access.repeatNewPassword')}
                  fullWidth
                  className="access__text-field"
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={confirmPassword}
                  onChange={e => confirmPasswordValidate(e)}
                />
              </Grid>

              {errorMsg && (
                <div className="access__message">
                  <span className="access__error-msg">{errorMsg}</span>
                </div>
              )}
              {successMsg && (
                <div className="access__message">
                  <span>{successMsg}</span>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid>
            <div className="access__footer-btn">
              <Button onClick={goBack} ghost noArrow label={t('personalData.Abortbtn')} />
              <Button disabled={!isValidPassword} onClick={savePassword} label={t('personalData.saveBtn')} />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export { Access };
